let Environment = {
  MintNftContract: "0x04E8038C4eFcC5BA965a85D592A8762568f7eadD",
};
export default Environment;
